'use client';

import * as React from 'react';

import { ToggleGroup, ToggleGroupItem } from '../toggle-group';

import type { QuoteDensity } from './density';

export interface QuoteDensityToggleLabels {
  densityLabel: string;
  densityFlat: string;
  densityAccordion: string;
}

export interface QuoteDensityToggleProps {
  value: QuoteDensity;
  onChange: (density: QuoteDensity) => void;
  labels: QuoteDensityToggleLabels;
}

export function QuoteDensityToggle({
  value,
  onChange,
  labels,
}: QuoteDensityToggleProps): React.ReactElement {
  return (
    <ToggleGroup
      type="single"
      size="sm"
      value={value}
      onValueChange={(next: string) => {
        if (next !== 'flat' && next !== 'accordion') return;
        onChange(next);
      }}
      aria-label={labels.densityLabel}
      className="border-input bg-muted/40 gap-0.5 rounded-lg border p-0.5"
      data-testid="quote-density-toggle"
    >
      <ToggleGroupItem
        value="flat"
        className="data-[state=on]:bg-card data-[state=on]:text-foreground h-7 px-2.5 text-xs font-medium data-[state=on]:shadow-sm"
        data-testid="quote-density-flat"
      >
        {labels.densityFlat}
      </ToggleGroupItem>
      <ToggleGroupItem
        value="accordion"
        className="data-[state=on]:bg-card data-[state=on]:text-foreground h-7 px-2.5 text-xs font-medium data-[state=on]:shadow-sm"
        data-testid="quote-density-accordion"
      >
        {labels.densityAccordion}
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
